<div id="video-overlay-settings-preview-animation" *ngIf="isShown">
    <div id="video-subtitle-settings" class="video-subtitle video-subtitle-fontsize-multiplier-{{subtitleFontSize}}"
        style="display: block;" (click)="$event.stopPropagation()">
        <span id="video-subtitle-inner-settings" class="video-subtitle-inner" [innerHTML]="currentSubtitle"
            (click)="openWordPopover(); $event.stopPropagation()"></span>
        <img #clickCursor id="click-cursor" src="assets/img/video-player/hand-pointer-icon-yellow.png" />
    </div>
</div>
